import { render } from "./language-switch.vue?vue&type=template&id=c28591ae&scoped=true"
import script from "./language-switch.vue?vue&type=script&lang=js"
export * from "./language-switch.vue?vue&type=script&lang=js"

import "./language-switch.vue?vue&type=style&index=0&id=c28591ae&lang=scss&scoped=true"

import exportComponent from "/home/gebruiker/www/fresh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c28591ae"]])

export default __exports__